import { jsx as _jsx } from "react/jsx-runtime";
import isNil from 'lodash/isNil';
import { IncaRowContext } from '../IncaRowContext';
import { useI18n } from '../../i18n';
import { useClearable } from '../../hooks/useClearable';
const defaultFilterFn = (x)=>!x._destroy;
const defaultRenderSeparator = ()=>/*#__PURE__*/ _jsx("hr", {});
const SubTableList = (props)=>{
    const { className = 'subtable-list', emptyContent, subTable, filterFn = defaultFilterFn, sortFn, renderRow, renderSeparator = defaultRenderSeparator } = props;
    const { t } = useI18n();
    const emptyMsg = emptyContent || t('subtable.empty');
    let rows = subTable.getRows();
    useClearable((row)=>row.clearSubTable(props.subTable.$rcc.tableName));
    if (filterFn) {
        rows = rows.filter((val)=>filterFn(val));
    }
    if (sortFn) {
        rows = rows.sort(sortFn);
    }
    if (rows.isEmpty()) {
        return /*#__PURE__*/ _jsx("div", {
            className: className,
            role: "list",
            children: emptyMsg
        });
    }
    const rowTemplates = rows.reduce((reduction, row, i)=>{
        // Guard för att Immutable-typesen suger.
        if (isNil(reduction) || isNil(row) || isNil(i)) {
            return reduction;
        }
        const rowId = row.getId();
        if (i > 0) {
            reduction.push(/*#__PURE__*/ _jsx("div", {
                className: "subtable-list-separator",
                children: renderSeparator()
            }, `${rowId}__SEPARATOR`));
        }
        reduction.push(/*#__PURE__*/ _jsx("div", {
            className: "subtable-list-item",
            role: "listitem",
            children: /*#__PURE__*/ _jsx(IncaRowContext, {
                tableName: row.$rcc.tableName,
                rowId: row.getId(),
                children: ({ dataActions })=>renderRow({
                        row,
                        dataActions: dataActions
                    })
            })
        }, rowId));
        return reduction;
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        className: className,
        role: "list",
        children: rowTemplates
    });
};
export default SubTableList;
